export default "__VITE_ASSET__8557bbd2__"